/**
 * client/wrapper type for the VideoGreet widget on parent/page
 */
import BaseWidgetClient from '../core/BaseWidgetClient';
import WidgetTypes from '../core/enums/WidgetTypes';
import TempCache from '../core/enums/TempCache';
import DropDownPositioner from '../core/positioners/DropDownPositioner';
import { Position } from '../core/enums/Enum';
import addStyleText from '../core/hooks/addStyleText';
import getStyle from '../core/hooks/getStyle';
import WidgetStates from '../core/hooks/WidgetStates';
import createNS from '../core/createNs';
import logIt from '../../logIt';

export default function RegisterVideoGreetInvitation() {
    const VideoGreet = class extends BaseWidgetClient {
        constructor(options) {
            if (!options.videoGreetEnabled) {
                return;
            }
            super(
                Object.assign(options, {
                    widget: WidgetTypes.VideoGreetInvitation
                })
            );
            this.positioner = new DropDownPositioner(this.options);
            this.ready();
        }

        ready() {
            super.ready();
            const me = this;
            this.subscribe('videogreet-auto-resizing', (args) => {
                try {
                    if (!me.options.isPreChatRoundedTheme) {
                        return;
                    }
                    const padding = 40; // padding and shadow
                    const extraHeightForSingleMsg = 5;
                    const extraHeightForStackedMsgs = 30;
                    // getting the videogreet Height/Width...
                    const VideoGreetHeight =
                        ApexChat.PreChatIconDimensions.Height + padding + closeButton.height;
                    const VideoGreetWidth = ApexChat.PreChatIconDimensions.Width + padding;
                    // getting iframe
                    const iframe = document.getElementById(me.iframeId);
                    // Hide All messages on CLOSE Press
                    const allAppearedMessages = me.$(
                        '.apexchat_prechat_message_bubble',
                        iframe.contentDocument
                    );
                    if (args.hideCloseButton && allAppearedMessages) {
                        allAppearedMessages.hide(); // hiding all messages..
                    }
                    const addedHeight = args.isSingleMsg
                        ? extraHeightForSingleMsg
                        : extraHeightForStackedMsgs; // incase of Single msg 5px, otherwise 30px
                    // expected height formula for giving to IFRAME
                    const expectedHeight =
                        (args.currentMsgHeight || 0) /* height of current message */ +
                        (args.prevMsgHeight ||
                            0) /* If prev. msg was not there or undefined height add 0 only */ +
                        VideoGreetHeight /* PreChat Circle invitation height */ +
                        addedHeight /* Padding and shadow etc. extra height */ +
                        (args.isErrorMsgForFT ? args.errorMsgHeight : 0); // Error msg expected hight
                    // updating heights with expected height.
                    TempCache.PRECHAT_Rounded_Message_Popup_Last_Height =
                        expectedHeight - VideoGreetHeight + addedHeight;
                    TempCache.PRECHAT_Rounded_Message_Popup_Current_Height =
                        expectedHeight - VideoGreetHeight + addedHeight;
                    // applying CSS for Height
                    me.$(me.$container).animate({ height: expectedHeight }, 1); // adding height to container and iframe..
                    me.$(iframe).animate({ height: expectedHeight }, 1);
                    const calculatedPosition =
                        expectedHeight -
                        closeButton.height -
                        parseInt(args.prevMsgHeight || extraHeightForSingleMsg) -
                        parseInt(args.prevMsgHeight ? addedHeight : 0) +
                        closeButton.padding;
                    const closeElement = me.$(
                        '#apexchat_prechat_rd_close_btn_icon',
                        iframe.contentDocument
                    );
                    // we need to check in some cases  If this flag is TRUE we need to hide all prechat messages.
                    if (
                        args.hidePreChatMessages &&
                        me.$('.apexchat_prechat_message_bubble', iframe.contentDocument)
                    ) {
                        me.$('.apexchat_prechat_message_bubble', iframe.contentDocument).hide();
                    }
                    /* Improved logic of hiding Close button as we dont need to show close button when its not supports i.e in DEFAULT animation
                    hideClosebutton: In case of CLOSE button Press
                    isClosebuttonSupported: If its not supported in case of Default animation.
                    */
                    if (
                        (args.hideCloseButton || !closeButton.isCloseButtonSupported) &&
                        closeElement
                    ) {
                        closeElement.hide();
                    } else {
                        closeElement.show();
                        /* Stacking-based animation supports Close button & dontAnimateCloseButton in some scenarios. */
                        if (closeButton.isCloseButtonSupported && !args.dontAnimateClosebutton) {
                            closeElement.animate({ bottom: calculatedPosition }, 200);
                        }
                    }
                    me.VideoGreetDefaultWidth =
                        me.VideoGreetDefaultWidth || getStyle(iframe, 'width');
                    if (args.isResetIframe) {
                        me.$(iframe).css({ width: VideoGreetWidth });
                        me.$(me.$container).css({ width: VideoGreetWidth });
                    } else {
                        me.$(iframe).css({ width: me.VideoGreetDefaultWidth });
                        me.$(me.$container).css({ width: me.VideoGreetDefaultWidth });
                    }
                } catch (e) {
                    logIt(e);
                }
            });
            this.subscribe('videogreet-size', (args) => {
                const iframe = document.getElementById(me.iframeId);
                let addValueWidth;
                let addValueHeight;
                if (args.isPreChatRoundedTheme) {
                    addValueWidth = args.addValue + 80;
                } else {
                    addValueWidth = args.addValue;
                    addValueHeight = args.addValue;
                }
                if (!args.isMobile && args.height && me?.options?.videoGreet?.chatBarEnabled && window.innerHeight < args.height) {
                    var chatBarContainer = document.getElementById(
                        'apexchat_bar_invitation_wrapper'
                    );
                    var chatBarHeight = chatBarContainer.offsetHeight;
                    var chatBarWidth = chatBarContainer.offsetWidth;
                    if (chatBarWidth > chatBarHeight) {
                        args.height = args.height - chatBarHeight;
                    }
                    if (chatBarWidth < chatBarHeight) {
                        args.width = args.width - chatBarWidth;
                    }
                }

                // remove maximized body class if VG is not maximized
                document.body.classList.remove('apexchat-video-greet-maximized-body');
                if (args.maximize) {
                    // add maximized body class when VG got maximized
                    document.body.classList.add('apexchat-video-greet-maximized-body');
                }

                iframe.style.width = `${args.width || ApexChat.WidgetMinimizedWidth}px`;
                iframe.style.height = `${args.height || ApexChat.WidgetMinimizedHeight}px`;
                me.$container.style.width = `${args.width + addValueWidth}px`;
                me.$container.style.height = `${args.height + addValueHeight}px`;
                me.$container.style.bottom = 0;
                me.positioner.position({
                    element: me.parentDivId,
                    widgetType: WidgetTypes.VideoGreetInvitation,
                    position: me.options.videoGreet.videoGreetPosition
                });
            });
            this.subscribe(
                WidgetTypes.VideoGreetInvitation + WidgetStates.Hidden,
                (args) => {
                    me.$container.style.display = 'none';
                }
            );
            this.subscribe(
                WidgetTypes.VideoGreetInvitation + WidgetStates.ShownMaximized,
                (args) => {
                    const DDState = me.state.getStateValue(WidgetTypes.DropDown);
                    if (DDState == WidgetStates.ShownMinimized) {
                        return;
                    }
                    me.$container.style.display = 'block';
                    me.positioner.position({
                        element: me.parentDivId,
                        widgetType: WidgetTypes.VideoGreetInvitation,
                        position: me.options.videoGreet.videoGreetPosition
                    });
                }
            );
            this.create();
        }

        create() {
            super.create();
            const self = this;
            addStyleText(this.options.invitationWidgetStyleCustom, 'test_css');

            self.$container.innerHTML = `<iframe class="${self.widget}_frame ${self.widget}_iframe_custom" id="${self.iframeId}" width="${self.options.width}" height="${self.options.height}" style="border: none;display: block;overflow-x:hidden; overflow-y:hidden;" marginheight="0" marginwidth="0" frameBorder="0" scrolling="no" horizontalscrolling="no" verticalscrolling="no"  allowtransparency="true" title="Chat Invitation"></iframe>`;
            document.body.appendChild(self.$container);
            self.$container.style.cssText = `margin: 10px;visibility: hidden; position: fixed; z-index:${TempCache.CONTAINER_Z_INDEX}; padding: 0px 10px 0px 0px`;
            if (
                self.options.videoGreet &&
                self.options.videoGreet.videoGreetPosition === Position.Right
            ) {
                self.$container.style.cssText += ' right:0px;';
            }
            this.show();
        }

        show() {
            super.show();
        }
    };
    const _fq_name = `apexchat_video_greet_invitation_client`;
    // Export to window
    createNS(_fq_name, VideoGreet);
}
